export enum IncidenceCondition {
    OPEN = 1,       // Abierta
    CLOSE = 2       // Cerrada
}